import { Box, CircularProgress, Divider, FormGroup, Typography } from "@mui/material"
import type { FC } from "react"
import type { Control } from "react-hook-form"

import type { GoodsReceiptFilterFormValues } from "../../types"

import { FilterCheckbox } from "@/components/common/Filters"
import type { Option } from "@/types/form-fields"

interface GoodsReceiptWarehouseFilterProps {
  control: Control<GoodsReceiptFilterFormValues, any>
  isFetching: boolean
  options: Option<string>[]
  selectedValues: string[]
  onChange: (warehouseIds: string[]) => void
}

export const GoodsReceiptWarehouseFilter: FC<GoodsReceiptWarehouseFilterProps> = ({
  control,
  isFetching,
  options,
  selectedValues,
  onChange,
}) => {
  return (
    <Box className='flex h-full flex-col'>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        Warehouse
      </Typography>
      <Divider />
      <Box className='flex-1 overflow-y-auto'>
        <FormGroup className='p-4'>
          {isFetching && (
            <Box display='flex' justifyContent='center'>
              <CircularProgress size={24} />
            </Box>
          )}

          {!isFetching && options.length === 0 && (
            <Box display='flex' justifyContent='center'>
              <Typography variant='body2' className='text-gray-500'>
                No warehouses found
              </Typography>
            </Box>
          )}

          {options.map((option) => (
            <FilterCheckbox
              key={option.value}
              control={control}
              name='warehouseAreaIds'
              value={option.value}
              values={selectedValues}
              label={option.label}
              onFilterChange={onChange}
            />
          ))}
        </FormGroup>
      </Box>
    </Box>
  )
}
